export const DEFAULT_PLACEHOLDER = 'Select';
export const NO_MATCH = 'Không có kết quả trùng khớp!';
export const NO_DATA = 'Chưa có dữ liệu!';
export const LOADING = 'Loading...';
export const ICON = {
  1: 'keyboard_arrow_down',
  0: 'keyboard_arrow_up',
};
